import React from "react";

import "./Checkout.css";
import CheckoutProduct from "./CheckoutProduct";
import { useStateValue } from "./Context";
import Subtotal from "./Subtotal";
import FlipMove from 'react-flip-move'

export default function Checkout() {
  const [{basket,user}, dispatch] = useStateValue()


  return (
    <div className="checkout">
      <div className="checkout_left">
        <img
          src="https://images-na.ssl-images-amazon.com/images/G/02/UK_CCMP/TM/OCC_Amazon1._CB423492668_.jpg"
          alt=""
          className="image_ad"
        />
        <div>
          <h3>Hello, {user?.email}</h3>
          <h2 className="checkout_title"> Your Shopping Basket</h2>
          <FlipMove  duration={250} easing="ease-in-out">
         
          {basket.map((item)=>(
            <div className="checkoutPro" >
            <CheckoutProduct 
            id={item.id}
            title={item.title}
            img={item.img}
            price={item.price}
            rating={item.rating}
            />
            </div>
            
          ))}
           </FlipMove>
         



        </div>
      </div>
      <div className="checkout_right">
        <Subtotal />
      </div>
    </div>
  );
}
